module.exports = __webpack_public_path__ + "static/media/bastille.1071991c.jpg";